/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleStatus,
    AdminGroupSaleStatusFromJSON,
    AdminGroupSaleStatusFromJSONTyped,
    AdminGroupSaleStatusToJSON,
} from './AdminGroupSaleStatus';

/**
 * 
 * @export
 * @interface AdminCreateGroupSale
 */
export interface AdminCreateGroupSale {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateGroupSale
     */
    name: string;
    /**
     * 
     * @type {AdminGroupSaleStatus}
     * @memberof AdminCreateGroupSale
     */
    status: AdminGroupSaleStatus;
}



export function AdminCreateGroupSaleFromJSON(json: any): AdminCreateGroupSale {
    return AdminCreateGroupSaleFromJSONTyped(json, false);
}

export function AdminCreateGroupSaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreateGroupSale {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': AdminGroupSaleStatusFromJSON(json['status']),
    };
}

export function AdminCreateGroupSaleToJSON(value?: AdminCreateGroupSale | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'status': AdminGroupSaleStatusToJSON(value.status),
    };
}

